import React from 'react';

/** Top action bar — title and action buttons. */
const DashboardHeader: React.FC = () => {
    return (
        <div className="row justify-content-between align-items-center mb-3 g-2">
            <div className="col">
                <h2 className="font-26 font-600 mb-0">
                    Vibrancy Dashboard
                </h2>
            </div>

        </div>
    );
};

export default DashboardHeader;

